
<b-form-invalid-feedback v-if="message" :id="id" :force-show="forceShow">
  <div class="d-flex mb-1 mt-1" :class="classesCSS">
    <div class="cercleErreur" :class="'cercleErreur-' + messageType">
      <span
        class="cercleErreur-contenu graphik_bold"
        :class="'cercleErreur-contenu-' + messageType"
        >!</span
      >
    </div>
    <div
      class="d-flex message-invalide ml-1"
      :class="'message-invalide-' + messageType"
      v-html="messageErreur"
    ></div>
  </div>
</b-form-invalid-feedback>
